// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__SVl-V","activePage":"Pagination_activePage__KExdk"};